import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { EditorBlock } from "draft-js";
import Placeholder from "editor/components/Placeholder";
import GhostConnect from "editor/components/GhostConnect";

import getActiveBlockKey from "editor/utils/getActiveBlockKey";
import styles from "./QuoteAttribution.css";
import { ATTRIBUTION_PLACEHOLDER } from "config/constants/editor";

export default class QuoteAttribution extends React.Component {
  constructor() {
    super();
    this.state = { quoteHasFocus: true, overrideForceSelection: false };

    this.ghostConnect = this._ghostConnect.bind(this);
  }

  isPlaceholderVisible() {
    return this.props.block.getText().length === 0;
  }

  getQuoteType() {
    return this.props.contentState
      .getBlockBefore(this.props.block.getKey())
      .getType()
      .split("-")[0];
  }

  _ghostConnect(connectProps) {
    const attributionKey = this.props.block.getKey();
    const quoteKey = connectProps.editorState
      .getCurrentContent()
      .getKeyBefore(attributionKey);
    const activeBlockKey = getActiveBlockKey(connectProps.editorState);
    const quoteHasFocus =
      attributionKey === activeBlockKey || quoteKey === activeBlockKey;
    //following if statement prevents selection bug caused by backspace-character changes
    //component only gets new selection prop for certain change types
    if (
      quoteHasFocus !== this.state.quoteHasFocus &&
      this.isPlaceholderVisible()
    ) {
      this.setState({ quoteHasFocus });
    }
    if (
      !this.state.overrideForceSelection &&
      activeBlockKey !== attributionKey
    ) {
      this.setState({ overrideForceSelection: true });
    } else if (
      this.state.overrideForceSelection &&
      activeBlockKey === attributionKey
    ) {
      this.setState({ overrideForceSelection: false });
    }
  }

  render() {
    /**
     * For a detailed explanation of the strangeness in this render (overrideForceSelection, hidden style, etc)
     * and why this fixes a selection bug, please see this confluence page:
     * https://confluence.axios.com/pages/viewpage.action?pageId=1279111
     */
    let placeholder = null;
    if (this.state.quoteHasFocus) {
      placeholder = (
        <Placeholder isVisible={this.isPlaceholderVisible()}>
          {ATTRIBUTION_PLACEHOLDER}
        </Placeholder>
      );
    }
    const { forceSelection, ...newProps } = this.props;
    newProps.forceSelection = this.state.overrideForceSelection
      ? false
      : forceSelection;

    return (
      <div
        className={classNames(
          styles.root,
          styles[
            this.isPlaceholderVisible() ? "placeholder" : "attributionText"
          ],
          {
            [styles.hidden]:
              !this.state.quoteHasFocus && this.isPlaceholderVisible(),
          }
        )}
      >
        <div className={styles.wrapper}>
          {placeholder}
          <EditorBlock {...newProps} />
          <GhostConnect ghostConnect={this.ghostConnect} />
        </div>
      </div>
    );
  }
}

QuoteAttribution.propTypes = {
  block: PropTypes.object.isRequired,
  contentState: PropTypes.object.isRequired,
};
